import { NavigateFunction } from "react-router-dom";
import {
  getComparator,
  stableSort,
} from "../../Alerts/AlertsUtils/alertsTableFunctions";

export const handleArrowButtonClickSMTP = (
  smtpData: any[],
  filteredData: any[],
  selectedRowSMTP: any,
  directionString: string,
  setSelectedRowSMTP: any,
  setSmtpData: any,
  setVideoClipLoadingSMTP: any,
  navigate: NavigateFunction,
  order: "asc" | "desc",
  orderBy: string,
  getVideoURLSMTP: any,
  onRowChange?: (row: any) => void
) => {
  // Get the sorted filtered data (same as what's displayed in the table)
  const sortedData = stableSort(filteredData, getComparator(order, orderBy));

  // Find the current selected row index in the sorted data
  const currentIndex = sortedData.findIndex(
    (item: any) => item.clip_id === selectedRowSMTP.clip_id
  );

  // Check if we can move in the requested direction
  const canMoveForward =
    directionString === "forward" && currentIndex < sortedData.length - 1;
  const canMoveBackward = directionString === "back" && currentIndex > 0;

  if (canMoveForward || canMoveBackward) {
    setVideoClipLoadingSMTP(true);

    // Determine the new selected row
    let newSelectedRow: any;
    if (directionString === "forward") {
      newSelectedRow = sortedData[currentIndex + 1];
    } else {
      newSelectedRow = sortedData[currentIndex - 1];
    }

    // Update the selected row
    setSelectedRowSMTP(newSelectedRow);
    localStorage.setItem("clipsSelectedRow", JSON.stringify(newSelectedRow));
    onRowChange?.(newSelectedRow);

    // Update the data to reflect the new selection
    const updatedSmtpData = smtpData.map((item: any) => ({
      ...item,
      selected: item.clip_id === newSelectedRow.clip_id,
    }));

    setSmtpData(updatedSmtpData);

    // Use the existing getVideoURLSMTP function from the store
    // This will handle the API call and set the appropriate video/photo URLs
    getVideoURLSMTP(newSelectedRow.clip_id, navigate);
  }
};
